// removed by extract-text-webpack-plugin
module.exports = {"root":"crops--root--1jf4F5xS home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","grid-container":"crops--grid-container--2xczLXdQ home--grid-container--3c3JLjRI","gridContainer":"crops--grid-container--2xczLXdQ home--grid-container--3c3JLjRI","form-container":"crops--form-container--3WSfKzx1 home--message--9FSspPIv","formContainer":"crops--form-container--3WSfKzx1 home--message--9FSspPIv","title":"crops--title--3nbOw3vq"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/cl-dealer/crops/styles.css
// module id = ./views/refunds/cl-dealer/crops/styles.css
// module chunks = 0